import React, { useEffect, useState } from 'react'
import { postObtenerTodosResultadosProcedimientos } from '../../../services/Clinico'
import Loading from '../../Loading'
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { UserTokenURL } from '../../../services/ApiHIS';
import ModalCrearUnResultadoProcedimiento from './ModalCrearUnResultadoProcedimiento';
import ModalModificarUnResultadoProcedimiento from './ModalModificarUnResultadoProcedimiento';
import ModalEliminarUnResultadoProcedimiento from './ModalEliminarUnResultadoProcedimiento';

const ResultadosProcedimientosPrincipal = () => {
    const [dataResultados, setdataResultados]=useState([])
    const [loading, setloading]=useState(true)
    const [selectCheckboxResultadosProcedimientos, setselectCheckboxResultadosProcedimientos]=useState(null)
    const [actualizarDataResultados, setactualizarDataResultados]=useState(null)
    const [modalOnCrearResultadoProcedimiento, setmodalOnCrearResultadoProcedimiento]=useState(false)
    const [modalOnModificarResultadoProcedimiento, setmodalOnModificarResultadoProcedimiento]=useState(false)
    const [modalOnDeleteResultadoProcedimiento, setmodalOnDeleteResultadoProcedimiento]=useState(false)
    const [dataUnResultadoProcedimiento, setdataUnResultadoProcedimiento]=useState(null)

    //token
    let query = new URLSearchParams(useLocation().search);
    let tokenCons = JSON.parse(query.get('token'));
    let location = useLocation();
    
    useEffect(() => {
        // Google Analytics
        localStorage.removeItem('tokenReact');
        localStorage.setItem('tokenReact',tokenCons)
    }, [location]);

    //token
    useEffect(()=>{
    
        //console.log(tokenCons,'tokenConstokenCons')
        const url = UserTokenURL()
    
        // Configurar la cabecera con el token JWT
        const headers = {
        Authorization: `Bearer ${tokenCons}`,
        };
    

        // Realiza la petición con Axios
        axios.get(url, { headers })
        .then(response => {
        //console.log(response, 'data user');

        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        //console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        //const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
        //console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')

        // Resto del código...
        })
        .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
        });
    },[])

    useEffect(()=>{
        setloading(false)
        setselectCheckboxResultadosProcedimientos(null)
        setdataUnResultadoProcedimiento(null)
        postObtenerTodosResultadosProcedimientos().then((res)=>{
            
            setloading(true)
            setdataResultados(res.data.data)
        })
    },[actualizarDataResultados])

    const handleOnsubmitBuscar=(e)=>{
        e.preventDefault()
        const buscar={
            "RNQCod": e.target.codigo.value,
            "RNQClv": e.target.clave.value,
            "RNQTip": e.target.tipoPRocedimiento.value
        }
        setloading(false)
        postObtenerTodosResultadosProcedimientos(buscar).then((res)=>{
            console.log(res.data.data,'data resultados')
            setloading(true)
            setdataResultados(res.data.data)
        })
    }

    const handleCheboxResultadosProcedimientos=(item)=>{
        setselectCheckboxResultadosProcedimientos(item.RNQCod)
        setdataUnResultadoProcedimiento(item)
    }

    const handleOnclickCreate=()=>{
        setmodalOnCrearResultadoProcedimiento(true)
    }

    const handleOnclickUpdate=()=>{
        if(dataUnResultadoProcedimiento){
            setmodalOnModificarResultadoProcedimiento(true)
        }        
    }

    const handleOnclickDelete=()=>{
      if(dataUnResultadoProcedimiento){
        setmodalOnDeleteResultadoProcedimiento(true)
      }    
    }
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#05a29d] font-medium pb-3">
          Resultados Procedimientos
        </div>
        <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex ">
            <div className="mb-3 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Codigo
              </label>
              <div className="flex">
                <input
                    autoComplete='off'
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-sm font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            <div className="mb-3 ml-2 xl:w-96">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Clave
              </label>
              <div className="flex">
                <input
                  autoComplete='off'
                  name="clave"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-sm font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
            </div>
            
            <div className="mb-3 pl-2">
            <label  className="form-label inline-block mb-2 text-gray-900 font-medium ml-2" >
                     Tipo Procedimiento
                </label>
              <div className="flex">
              <div  className="mb-3 xl:w-96 pl-2">
                
                <select className="form-select block  w-full px-2 py-0.5 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                
                name='tipoPRocedimiento'
                >
                                        
                                        <option value="">Todos</option>
                                        <option value="1">Imagenes diagnosticas</option>
                                        <option value="2">Laboratorios</option>
                                        <option value="3">Terapias</option>
                                        <option value="4">Procedimientos NO Qx</option>
                                        <option value="5">Procedimientos Qx</option>
                                        <option value="6">InterConsultas</option>
                                        <option value="7">Dietas</option>
                                        <option value="8">Recomendaciones</option>
                                        <option value="9">Certificados</option>
                                        <option value="10">Conclusiones</option>
                                        <option value="11">Contraindicaciones (CTC)</option>
                                        <option value="12">Justificación Uso (CTC)</option>
                                        <option value="13">Indicaciones de tratamiento (CTC)</option>
                                        <option value="14">Preparación de la Cirugía</option>
                                        <option value="15">Resultados Antecedentes Gineco</option>
                                        
                                        
                                    </select>
                                    
            </div>

                <div className="px-3">
                  <button
                    type="submit"
                    className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          
                
        </form>
        <div className="flex ">
          
        <button
        onClick={handleOnclickCreate}
        type="button"
        className="inline-block px-6 py-1.5 bg-violet-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-violet-700 hover:shadow-lg focus:bg-violet-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-violet-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Crear
      </button>
      
      <div className='px-2'>
      <button
                  onClick={handleOnclickUpdate}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Modificar 
                </button>
      </div>
      {/* <div className='px-2'>
      <button
                  onClick={handleOnclickConsultar}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-yellow-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-yellow-700 hover:shadow-lg focus:bg-yellow-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Consultar
                </button>      
      </div> */}
      <div className='px-2'>
      <button
                  onClick={handleOnclickDelete}
                  type="button"
                  className="inline-block px-6 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Eliminar
                </button>
      </div>
      
      </div>
        
        <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                    <th></th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900  py-2 "
                      >
                        Codigo
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Palabra Clave
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Tipo Procedimiento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 bg-gray-200"
                      >
                        Descripción
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {
                    loading?
                    dataResultados.map((item,index)=>(
                        <tr className=" divide-y divide-slate-700 " key={index}>
                        <td></td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          <div className="topping">
                            <input
                              type="checkbox"
                              checked={selectCheckboxResultadosProcedimientos === item.RNQCod}
                              onChange={() => handleCheboxResultadosProcedimientos(item)}
                            />                          
                          </div>
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                          {item.RNQCod}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                          {item.RNQClv}
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">                          
                          {parseInt(item.RNQTip) === 1? 'Imagenes diagnosticas':null}
                          {parseInt(item.RNQTip) === 2? 'Laboratorios':null}
                          {parseInt(item.RNQTip) === 3? 'Terapias':null}
                          {parseInt(item.RNQTip) === 4? 'Procedimientos NO Qx':null}
                          {parseInt(item.RNQTip) === 5? 'Procedimientos Qx':null}
                          {parseInt(item.RNQTip) === 6? 'InterConsultas':null}
                          {parseInt(item.RNQTip) === 7? 'Dietas':null}
                          {parseInt(item.RNQTip) === 8? 'Recomendaciones':null}
                          {parseInt(item.RNQTip) === 9? 'Certificados':null}
                          {parseInt(item.RNQTip) === 10? 'Conclusiones':null}
                          {parseInt(item.RNQTip) === 11? 'Contraindicaciones (CTC)':null}
                          {parseInt(item.RNQTip) === 12? 'Justificación Uso (CTC)':null}
                          {parseInt(item.RNQTip) === 13? 'Indicaciones de tratamiento (CTC)':null}
                          {parseInt(item.RNQTip) === 14? 'Preparación de la Cirugía':null}
                          {parseInt(item.RNQTip) === 15? 'Resultados Antecedentes Gineco':null}
                          
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                          {/* {item.RNQDes} */}
                          <div dangerouslySetInnerHTML={{ __html: item.RNQDes }} />
                        </td>
                        
                      </tr>
                    ))
                    :
                    <tr className="divide-y divide-slate-700 ">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                      <td></td>
                      
                      </tr>
                  }
                  </tbody>
                  
                    
                  
                </table>
              </div>
            </div>
          </div>
        </div> 
      </div>
      {modalOnCrearResultadoProcedimiento? <ModalCrearUnResultadoProcedimiento setmodalOnCrearResultadoProcedimiento={setmodalOnCrearResultadoProcedimiento} setactualizarDataResultados={setactualizarDataResultados}/>:null}
      {modalOnModificarResultadoProcedimiento? <ModalModificarUnResultadoProcedimiento setmodalOnModificarResultadoProcedimiento={setmodalOnModificarResultadoProcedimiento} dataUnResultadoProcedimiento={dataUnResultadoProcedimiento} setactualizarDataResultados={setactualizarDataResultados}/>:null}
      {modalOnDeleteResultadoProcedimiento? <ModalEliminarUnResultadoProcedimiento setmodalOnDeleteResultadoProcedimiento={setmodalOnDeleteResultadoProcedimiento} dataUnResultadoProcedimiento={dataUnResultadoProcedimiento} setactualizarDataResultados={setactualizarDataResultados}/>:null}
    </>
  )
}

export default ResultadosProcedimientosPrincipal